import { ACTION_CREDENTIALS_EXPOSED_DIALOG_CLICK_RESET } from 'utils/analytics/eventTypeConstantsAmplitude';
import { Button, Dialog, DialogActions, DialogContent, DialogHeading, Typography } from 'omakase';
import { useActions } from '@tock/shared/utils/connect';
import { useAmplitudeSendEvent } from 'utils/analytics/AnalyticsContext';
import { useState } from 'react';

interface Props {
  isOpen: boolean;
  onClose: () => void;
  email: string;
}

const CredentialsExposedDialog: React.FC<Props> = ({ isOpen, onClose, email }) => {
  const amplitudeSendEvent = useAmplitudeSendEvent();
  const { actions } = useActions();
  const [hasClicked, setHasClicked] = useState(false);

  const handleResetPassword = () => {
    amplitudeSendEvent(ACTION_CREDENTIALS_EXPOSED_DIALOG_CLICK_RESET);
    actions.app.resetPassword(email, 'TOAST', { showToast: false });
    setHasClicked(true);
  };
  return (
    <Dialog open={isOpen} onClose={onClose} variant="sheet" maxContent>
      <DialogHeading onClose={onClose}>
        {hasClicked ? 'Check your inbox' : 'Please reset your password'}
      </DialogHeading>
      <DialogContent>
        <Typography mb={2} variant="body02" component="p">
          {hasClicked
            ? `We've sent password reset instructions to ${email}.`
            : 'Your current password appears in one or more public exposed password databases. Please update to a unique, secure, password for your Tock account as soon as possible.'}
        </Typography>
      </DialogContent>
      <DialogActions>
        <Button
          fullWidth
          variant="primary"
          size="medium"
          onClick={handleResetPassword}
          disabled={hasClicked}
        >
          Reset password
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default CredentialsExposedDialog;
